import { useTranslation } from 'react-i18next';

import { useGetBalanceQuery } from '@app/store/slices/balance/balanceApi';
import notification from '@app/shared/utils/notification';
import { PriceType } from '@app/shared/types/common';

export const useBalance = () => {
  const { t } = useTranslation();
  const {
    data: balance,
    isFetching,
    error,
    isError,
    refetch,
  } = useGetBalanceQuery(undefined, {
    refetchOnMountOrArgChange: false,
  });

  const tonBalance = Number(balance?.tonBalance ?? 0);
  const tonTotalIncome = Number(balance?.tonTotalIncome ?? 0);
  const cookieBalance = Number(balance?.cookieBalance ?? 0);

  const fetchBalance = async () => {
    try {
      await refetch();
    } catch {
      notification.error(t('errors.failed_to_load_balance'));
    }
  };

  const isBalanceEnough = (type: PriceType, amount: number): boolean => {
    if (type === PriceType.TON) return tonBalance >= amount;
    if (type === PriceType.COOKIE) return cookieBalance >= amount;
    return false;
  };

  return {
    tonBalance,
    tonTotalIncome,
    cookieBalance,
    balance,
    fetchBalance,
    isFetching,
    isError,
    error,
    isBalanceEnough,
  };
};
